import { render, staticRenderFns } from "./ITRSimpleQuestionCard.vue?vue&type=template&id=0b658d12&scoped=true&"
import script from "./ITRSimpleQuestionCard.vue?vue&type=script&lang=ts&"
export * from "./ITRSimpleQuestionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b658d12",
  null
  
)

export default component.exports